export default "__VITE_ASSET__tfroHJac__"